module.exports = __webpack_public_path__ + "static/blocFooter-c4ea417500573a423c07d0dad6343148.png";